/*@ngInject*/
const BaseRepository = function ($http, $q) {

    function onSuccess(response) {
        if (response) {
            switch (response.config.method) {
                case 'GET':
                    return this.processGetResponseData(response.data);

                case 'POST':
                    return this.processPostResponseData(response.data);

                case 'DELETE':
                    return this.processDeleteResponseData(response.data);
            }
        } else {
            return $q.reject();
        }
    }

    function onError(errorResponse) {
        return $q.reject(errorResponse.data);
    }

    this.get = function (url, config) {
        return $http.get(url, config).then(onSuccess.bind(this), onError);
    };

    this.processGetResponseData = function (responseData) {
        return responseData;
    };

    this.delete = function (url, config) {
        return $http.delete(url, config).then(onSuccess.bind(this), onError);
    };

    this.processDeleteResponseData = function (responseData) {
        return responseData;
    };

    this.post = function (url, formData, config) {
        return $http.post(url, formData, config).then(onSuccess.bind(this), onError);
    };

    this.processPostResponseData = function (responseData) {
        return responseData;
    };
};

angular.module('umCore')
    .service('baseRepository', BaseRepository);
